import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class ReportTailorWorkService extends GenericService {
  constructor() {
    super('/reports/tailor_work', axiosInstance);
  }
}

export default new ReportTailorWorkService(); 